import { computed, ref, watch } from 'vue'

const STORAGE_KEY = 'tamepulse.chat.widget.mode'
const mode = ref(readMode())
const widgetVisible = ref(false)
const workspaceOffset = ref('4.75rem')

const isClosed = computed(() => mode.value === 'closed')
const sidebarActive = computed(() => widgetVisible.value && mode.value === 'panel')

watch(mode, (value) => {
    persistMode(value)
})

export function useTamepulseChatWidget() {
    return {
        mode,
        widgetVisible,
        workspaceOffset,
        isClosed,
        sidebarActive,
        openPanel,
        expandPanel,
        closePanel,
        setWidgetVisible,
        setWorkspaceOffset,
    }
}

function openPanel() {
    mode.value = 'panel'
}

function expandPanel() {
    mode.value = 'expanded'
}

function closePanel() {
    mode.value = 'closed'
}

function setWidgetVisible(value) {
    widgetVisible.value = Boolean(value)
}

function setWorkspaceOffset(value) {
    workspaceOffset.value = value
}

function readMode() {
    try {
        const value = window.localStorage.getItem(STORAGE_KEY)

        return ['closed', 'panel', 'expanded'].includes(value) ? value : 'closed'
    } catch {
        return 'closed'
    }
}

function persistMode(value) {
    try {
        window.localStorage.setItem(STORAGE_KEY, value)
    } catch {
        // La preferenza resta disponibile solo per la sessione corrente.
    }
}
